module.exports = __webpack_public_path__ + "static/media/diy_hybrid_icon.e2355dca.svg";